import { createSelector } from "reselect";

const viewType = (state) => state.designChapter.currentView.viewType;

export const getViewType = createSelector([viewType], (viewType) => viewType);

const title = (state) => state.designChapter.currentView.title;

export const getTitle = createSelector([title], (title) => title);

const description = (state) => state.designChapter.currentView.description;

export const getDescription = createSelector(
  [description],
  (description) => description
);

const slideTree = (state) => state.designChapter.currentView.slideTree;

export const getSlideTree = createSelector(
  [slideTree],
  (slideTree) => slideTree
);
